module.exports = __webpack_public_path__ + "img/no-questionnaires.4bd2f8ea.svg";